<template>
  <div>
    <!-- <h5 class="control-label col-md-3">服務 (打勾為 "是"):</h5> -->
    <div class="col-md-9">
      <div class="col-md-12">
        <template v-for="(item, index) in apiServiceList" class="inputNumber">
          <label>
            <span class="checkbox_inline">
              <input
                v-model="item.active"
                :value="item.name"
                :disabled="edit_info"
                @click="_check($event, index)"
                type="checkbox"
                class="flat"
                style="width: 16px; height: 16px"
              />
              <span class="fontSize16" style="color: #000000">
                {{ item.name }}
              </span>
            </span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * input 司機目前有哪些服務與客製服務
 *        司機車輛年齡
 *        車輛種類
 * output 司機已選服務與客製服務
 */
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    edit_info: {
      type: Boolean,
      default: false,
    },
    /* car_year: {
      type: Number,
    }, */
  },
  data() {
    return {
      service: [],
      apiServiceList: [],
    }
  },
  computed: {
    ...mapGetters('serviceStore', {
      getServiceResultList: 'getServiceList',
    }),
  },
  methods: {
    ...mapActions({
      vx_fetchServiceList: 'serviceStore/fetchServiceList',
    }),
    getServiceList() {
      return this.service
    },
    setfillOutServiceListCheckBox(driverServiceList) {
      /* console.log('driverServiceList', driverServiceList) */
      // 確保 apiServiceList 已載入，如果還沒載入則等待
      const setCheckBox = () => {
        // 如果 apiServiceList 還是空的，等待一下再試
        if (!this.apiServiceList || this.apiServiceList.length === 0) {
          setTimeout(setCheckBox, 100)
          return
        }

        this.service = []
        if (!Array.isArray(driverServiceList)) {
          return
        }

        // 使用 Vue.set 確保響應式更新
        for (let i = 0; i < driverServiceList.length; i++) {
          let index = this.apiServiceList
            .map((e) => {
              return e.id
            })
            .indexOf(driverServiceList[i].serivceId)
          if (index > -1) {
            // 使用 Vue.set 確保響應式更新
            this.$set(this.apiServiceList[index], 'active', true)
            this.service.push(driverServiceList[i].serivceId)
          }
        }
        // 強制觸發響應式更新
        this.$forceUpdate()
      }

      // 立即嘗試一次，如果還沒準備好會自動重試
      this.$nextTick(() => {
        setCheckBox()
      })
    },
    setfillOutServiceListCheckBoxArray(driverServiceList) {
      /* console.log(this.apiServiceList) */
      // 確保 apiServiceList 已載入，如果還沒載入則等待
      const setCheckBox = () => {
        // 如果 apiServiceList 還是空的，等待一下再試
        if (!this.apiServiceList || this.apiServiceList.length === 0) {
          setTimeout(setCheckBox, 100)
          return
        }

        this.service = []
        if (!Array.isArray(driverServiceList)) {
          return
        }

        // 使用 Vue.set 確保響應式更新
        for (let i = 0; i < driverServiceList.length; i++) {
          let index = this.apiServiceList
            .map((e) => {
              return e.id
            })
            .indexOf(parseInt(driverServiceList[i]))
          if (index > -1) {
            // 使用 Vue.set 確保響應式更新
            this.$set(this.apiServiceList[index], 'active', true)
            this.service.push(parseInt(driverServiceList[i]))
          }
        }
        // 強制觸發響應式更新
        this.$forceUpdate()
      }

      // 立即嘗試一次，如果還沒準備好會自動重試
      this.$nextTick(() => {
        setCheckBox()
      })
    },
    _check(e, index) {
      // 確保 index 有效且 apiServiceList 已載入
      if (!this.apiServiceList || !this.apiServiceList[index]) {
        return
      }

      const serviceId = this.apiServiceList[index].id

      if (e.target.checked) {
        // 確保不會重複添加
        if (this.service.indexOf(serviceId) === -1) {
          this.service.push(serviceId)
        }
        // 使用 Vue.set 確保響應式更新
        this.$set(this.apiServiceList[index], 'active', true)
      } else {
        // 無點選，從中刪除
        this._deleteCheckedService(serviceId)
        // 使用 Vue.set 確保響應式更新
        this.$set(this.apiServiceList[index], 'active', false)
      }
    },
    _deleteCheckedService(value) {
      let index = this.service.indexOf(value)
      if (index > -1) {
        this.service.splice(index, 1)
      }
    },
    async _requestcustomerizeServiceList() {
      try {
        await this.vx_fetchServiceList()
        // 確保取得服務列表
        const serviceList = this.getServiceResultList
        if (!serviceList || serviceList.length === 0) {
          console.warn('服務列表為空')
          return
        }

        // 深拷貝並初始化 active 屬性
        this.apiServiceList = serviceList.map((item) => ({
          ...item,
          active: false,
        }))

        // 強制觸發響應式更新
        this.$forceUpdate()
      } catch (e) {
        console.error('載入服務列表失敗:', e)
      }
    },
    clearService() {
      if (!this.apiServiceList || this.apiServiceList.length === 0) return
      for (let i = 0; i < this.apiServiceList.length; i++) {
        // 使用 Vue.set 確保響應式更新
        this.$set(this.apiServiceList[i], 'active', false)
      }
      this.service = []
      // 強制觸發響應式更新
      this.$forceUpdate()
    },
    /**
     * 根據年份自動勾選「五年新車」服務
     * @param {number|string} year - 製造年份或完整日期
     */
    onSetNewCar(year) {
      let now = new Date()
      // robust解析: 支援 'YYYY'、'YYYY-MM'、'YYYY-MM-DD'
      let carDate = null
      if (typeof year === 'string') {
        let parts = year.split('-')
        let y = parseInt(parts[0], 10)
        let m = parts[1] ? parseInt(parts[1], 10) - 1 : 0 // 月份從0開始
        let d = parts[2] ? parseInt(parts[2], 10) : 1
        carDate = new Date(y, m, d)
      } else {
        carDate = new Date(year + '-01-01')
      }
      // 計算五年前的今天（精確到年月日）
      let fiveYearsAgo = new Date(
        now.getFullYear() - 5,
        now.getMonth(),
        now.getDate(),
      )
      // 取得五年新車服務的 index
      let serviceIndex = this.apiServiceList.findIndex(function (item) {
        return (
          item.name === '五年新車' || item.value === 'car_within_five_years'
        )
      })
      if (serviceIndex === -1) return
      if (carDate.getTime() >= fiveYearsAgo.getTime()) {
        this.apiServiceList[serviceIndex].active = true
        if (this.service.indexOf(this.apiServiceList[serviceIndex].id) === -1) {
          this.service.push(this.apiServiceList[serviceIndex].id)
        }
      } else {
        this.apiServiceList[serviceIndex].active = false
        this._deleteCheckedService(this.apiServiceList[serviceIndex].id)
      }
      // 深拷貝，強制更新
      this.apiServiceList = JSON.parse(JSON.stringify(this.apiServiceList))
    },
  },
  /* created() {
    console.log('created fetch service list')
    this._requestcustomerizeServiceList()
  }, */
  mounted() {
    /* console.log('mounted fetch service list') */
    /* this.vx_fetchServiceList() */
    this._requestcustomerizeServiceList()
  },
}
</script>
<style scoped>
.danger-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/driver/DriverServiceCheckBox_1.vue